import React, { useState } from 'react';
import { toast } from 'sonner';
import { Panel, Empty, StatusBadge } from '../../components/Primitives';
import { useFetch } from '../../lib/hooks';
import { api, errMsg, fmtUsd, fmtDate, shortHash } from '../../lib/api';

export default function AdminWithdrawals() {
  const { data: rows, reload } = useFetch('/admin/withdrawals', [], 20000);

  const approve = async (id) => { try { await api.post(`/admin/withdrawals/${id}/approve`); toast.success('Approved'); reload(); } catch (e) { toast.error(errMsg(e)); } };
  const reject = async (id) => { try { await api.post(`/admin/withdrawals/${id}/reject`); toast.success('Rejected & funds returned'); reload(); } catch (e) { toast.error(errMsg(e)); } };
  const complete = async (id) => {
    const tx = window.prompt('Enter the real on-chain transaction hash (0x…):');
    if (!tx) return;
    try { await api.post(`/admin/withdrawals/${id}/complete`, { tx_hash: tx }); toast.success('Marked completed'); reload(); }
    catch (e) { toast.error(errMsg(e)); }
  };

  return (
    <div data-testid="admin-withdrawals">
      <Panel title="Withdrawal Management">
        {rows && rows.length ? (
          <div className="overflow-x-auto"><table className="w-full text-sm">
            <thead><tr className="text-left text-xs text-vj-grey border-b border-border"><th className="py-2 font-medium">User</th><th className="font-medium">Amount</th><th className="font-medium">To</th><th className="font-medium">Status</th><th className="font-medium">Tx</th><th className="font-medium">Actions</th></tr></thead>
            <tbody>{rows.map((w) => (
              <tr key={w.id} className="border-b border-border last:border-0">
                <td className="py-2.5 text-xs">{w.user_email}</td>
                <td className="font-mono">{fmtUsd(w.amount)}</td>
                <td className="font-mono text-xs">{shortHash(w.address)}</td>
                <td><StatusBadge status={w.status} /></td>
                <td className="font-mono text-xs text-vj-grey">{w.tx_hash ? shortHash(w.tx_hash) : '—'}</td>
                <td>
                  <div className="flex gap-1.5 flex-wrap">
                    {w.status === 'pending_admin_approval' && <>
                      <button onClick={() => approve(w.id)} className="h-7 px-2.5 rounded-md bg-vj-neon/15 text-vj-neon text-xs" data-testid={`wd-approve-${w.id}`}>Approve</button>
                      <button onClick={() => reject(w.id)} className="h-7 px-2.5 rounded-md bg-vj-red/15 text-vj-red text-xs" data-testid={`wd-reject-${w.id}`}>Reject</button>
                    </>}
                    {['approved', 'processing'].includes(w.status) && <button onClick={() => complete(w.id)} className="h-7 px-2.5 rounded-md bg-vj-gold/15 text-vj-gold text-xs" data-testid={`wd-complete-${w.id}`}>Mark Completed</button>}
                    {['completed', 'rejected'].includes(w.status) && <span className="text-xs text-vj-grey">—</span>}
                  </div>
                </td>
              </tr>
            ))}</tbody>
          </table></div>
        ) : <Empty>No withdrawal requests.</Empty>}
      </Panel>
    </div>
  );
}
